import {
  ArrowLeft01Icon,
  ArrowRight01Icon,
  CancelIcon,
  MoreHorizontalIcon,
} from '@hugeicons-pro/core-stroke-rounded';
import { HugeiconsIcon } from '@hugeicons/react';
import { cn } from '@/ui/utils';

export function Icon({
  strokeWidth = 1.5,
  className,
  ...props
}: React.ComponentProps<typeof HugeiconsIcon>) {
  return (
    <HugeiconsIcon
      className={cn(
        'shrink-0',
        [CancelIcon, MoreHorizontalIcon, ArrowLeft01Icon, ArrowRight01Icon].includes(props.icon) &&
          'scale-115',
        className,
      )}
      strokeWidth={props.icon.some(([, attrs]) => 'stroke' in attrs) ? strokeWidth : undefined}
      {...props}
    />
  );
}
